import React, { useEffect, useState } from "react";
import Pagination from "../../extras/Pagination";
import Table from "../../extras/Table";
import Analytics from "../../extras/Analytics";
import Title from "../../extras/Title";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getSalonBookings } from "../../../redux/slice/salonSlice";
import CancleDetails from "../booking/CancleDetails";
import CancelBookingDialog from "../booking/CancelBookingDialog";
import { permissionError } from "../../../util/Alert";

const SalonBooking = () => {
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const { booking, total } = useSelector((state) => state.salon);
  const { setting } = useSelector((state) => state.setting);
  const state = useLocation();

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [type, setType] = useState("ALL");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");
  const navigate = useNavigate();

  const payload = {
    start: page,
    limit: rowsPerPage,
    salonId: state?.state?.data?._id,
    type,
    startDate,
    endDate,
  };

  useEffect(() => {
    dispatch(getSalonBookings({ ...payload, command: true }));
  }, [page, rowsPerPage, state, type, startDate, endDate]);

  useEffect(() => {
    setData(booking);
  }, [booking]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const [search, setSearch] = useState("");

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const handleInfo = (id) => {
    navigate("/admin/expert/getExpertProfile", {
      state: {
        id,
      },
    });
  };

  const handleUserInfo = (id) => {
    navigate("/admin/user/userProfile", {
      state: {
        id,
      },
    });
  };

  const bookingTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "User",
      Cell: ({ row }) => (
        <div
          className="userProfile cursor"
          
        >
          <img
            src={row?.user?.image}
            alt=""
            onClick={() => handleUserInfo(row?.user?._id)}
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
          />
        </div>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => (
        <span
          className="text-capitalize  cursor"
          onClick={() => handleUserInfo(row?.user?._id)}
        >
          {row?.user?.fname
            ? row?.user?.fname + " " + row?.user?.lname
            : "Salon User"}
        </span>
      ),
    },
    {
      Header: "Expert",
      Cell: ({ row }) => (
        <span
          className="text-capitalize  cursor"
          onClick={() => handleInfo(row?.expert?._id)}
        >
          {row?.expert?.fullName}
        </span>
      ),
    },
    {
      Header: "Service",
      Cell: ({ row }) => (
        <div>
          {row?.services?.map((dur, index) => (
            <span key={index} className="text-capitalize">
              {dur?.name}
              {index !== row?.services?.length - 1 && <br />}
            </span>
          ))}
        </div>
      ),
    },
    {
      Header: "Booking Id",
      body: "bookingId",
      sorting: { type: "client" },
    },
    {
      Header: `Price `,
      body: "rupee",
      Cell: ({ row }) => (
        <span className="text-capitalize ">
          {row?.amount?.toFixed(2) + " " + (setting?.currencySymbol || "$")}
        </span>
      ),
      sorting: { type: "client" },
    },
    {
      Header: `Admin Commission `,
      body: "commission",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <span className="text-capitalize ">
          {row?.status == "cancel"
            ? "-"
            : row?.platformFee?.toFixed(2) + " " + (setting?.currencySymbol || "$")}
        </span>
      ),
    },
    {
      Header: "Duration",
      body: "duration",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.duration + " " + "Min"}</span>
      ),
    },
    {
      Header: "Date",
      body: "date",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.date ? row?.date : "-"}</span>
      ),
    },
    {
      Header: "Status",
      Cell: ({ row }) =>
        row?.status === "completed" ? (
          <button className="badge-success ">
            Completed
          </button>
        ) : row?.status === "confirm" ? (
          <button className="badge-warning ">
            Confirm
          </button>
        ) : row?.status === "cancel" ? (
          <button
            className="badge-danger "
            style={{ cursor: "pointer" }}
            onClick={() => handleOpenDialogue(row)}
          >
            Cancel
          </button>
        ) : (
              <button
                className=" badge-primary"
                onClick={() => handleCancel(row._id)}
              >
                Pending
              </button>
           
        ),
    },
    {
      Header: "First Slot",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.time ? row?.time[0] : "-"}
        </span>
      ),
    },
  ];

  const handleCancel = (row) => {
    dispatch(openDialog({ type: "cancelBooking", data: row }));
  };

  const handleOpenDialogue = (row) => {
    dispatch(openDialog({ type: "cancel", data: row }));
  };

  const bookingType = [
    { name: "Pending", value: "pending" },
    { name: "Confirm", value: "confirm" },
    { name: "Completed", value: "completed" },
    { name: "Cancelled", value: "cancel" },
  ];

  return (
    <>
    <div className="userPage">
        <div className=" d-flex justify-content-end mb-3">
          <Analytics
            analyticsStartDate={startDate}
            analyticsStartEnd={endDate}
            analyticsStartDateSet={setStartDate}
            analyticsStartEndSet={setEndDate}
          />
        </div>
      <div className="user-table mb-3">

        <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5 className="main-title">
                {state ? state?.state?.data?.name : ""}'s Bookings
              </h5>
            </div>
            <div className="d-flex gap-2 justify-content-end w-100">
              <div className="inputData w-25">
                
                <select
                  name="bookingType"
                  className="form-select"
                  id="bookingType"
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                  }}
                >
                  <option value="ALL" selected>
                    All
                  </option>
                  {bookingType?.map((data) => {
                    return <option value={data?.value}>{data?.name}</option>;
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-2"></div>
        </div>

        <div>
          <Table
            data={data}
            mapData={bookingTable}
            serverPerPage={rowsPerPage}
            serverSearching={handleFilterData}
            type={"server"}
          />
          <Pagination
            type={"server"}
            serverPage={page}
            setServerPage={setPage}
            serverPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalData={total}
          />
        </div>
      </div>
    </div>
        {dialogue && dialogueType === "cancel" && (
          <CancleDetails setData={setData} data={data} />
        )}
        {dialogue && dialogueType === "cancelBooking" && (
          <CancelBookingDialog setData={setData} data={data} />
        )}
    </>
  );
};

export default SalonBooking;
